import {injectPlaceholder, isAnnualReturnNA, isPercentPassiveNA, isMandateStyleNA, costBaseThousandsNA, performanceFeesNA, underlyingFeesNA, isFeeBasisNA } from "../helpers";
import ibsStore from "../components/Stores/IbsSurveyStore"
import store from "../components/Stores/SurveyStore"
import { NumberFormat } from "../Enums/constants";
import { deleteRowCtrl } from "../control";
import { log } from "util";
import { getSurveyResponseValue } from "./General/SurveyResponsesHelper";

export function getHiddenColumns (props) {
    let hideCols = []
    if (props.hiddenColumns && props.hiddenColumns.length > 0) hideCols = hideCols.concat(props.hiddenColumns), props;

    if (props.hideExtraColumns) {
        let extraCols = props.hideExtraColumns()
        hideCols = hideCols.concat(extraCols)
    }

    //always hide row ID, would be better if we could save the rowID in ID tag on td
    const rowIdCol = props.headers.findIndex((element) => (element === "RowID" || element === "CustomAssetID" || element === "OptionID"));
    if (rowIdCol > -1)
        hideCols.push(rowIdCol) 

    return (hideCols)

}

export function getHiddenRows(props, referenceToTable) {
    const rowIndicesToHide = [];

    switch (props.tableName) {
        case "Expenses":
            if (ibsStore.currentSurvey) {
                if (!ibsStore.isEnhanced) {
                    // hide custodial fees row if not enhanced
                    rowIndicesToHide.push(referenceToTable.findIndex(rowData => rowData.SupportActivityID === 7));
                }
            }
            break;
    }

    return rowIndicesToHide;
}


/**
 * helper dictionary for isNumField
 * @type {{}} qId: isNumField
 */
const isNumFieldDictionary = {};

/**
 * Checks whether the column with propQid = qId is a number field or not
 * @returns {boolean}
 */
export function isNumField(table, qId, props) {
    // check if answer is ready
    if (qId in isNumFieldDictionary) {
        return isNumFieldDictionary[qId];
    }

    let cellFormat = getCellFormat(table, qId, props);
    const isNumField = Object.values(NumberFormat).indexOf(cellFormat) > -1;

    // save result
    isNumFieldDictionary[qId] = isNumField;

    return isNumField;
}
/**
     * helper dictionary for getCellFormat
     * @type {{}} { qId: cellFormat }
     */
const cellFormatDictionary = {};

/**
 * Returns cached cellFormat from props.formatting[col]
 * @param table
 * @param qId
 */
function getCellFormat(table, qId, props) {
    // check if answer is ready
    if (qId in cellFormatDictionary) {
        return cellFormatDictionary[qId];
    }

    const col = table.propToCol(qId);

    let cellFormat = undefined;
    if (props.formatting && props.formatting[col])
        cellFormat = props.formatting[col];

    // save result
    cellFormatDictionary[qId] = cellFormat;

    return cellFormat;
}

export function manageContainerWidth(reRender = false, hotTableInstance, props) {
    if (hotTableInstance?.current?.hotInstance) {
        let allColumns = props.columns.map((v, i) => i);
        let columnWidths = allColumns.map(x => hotTableInstance.current.hotInstance.getColWidth(x));
        let myTotalWidth = columnWidths.reduce((a, b) => a + b, 0);
        let finalWidth = myTotalWidth * 1.1 + 370;
        hotTableInstance.current.hotInstance.rootElement.parentElement.style.width = `${finalWidth}px`;

        let wtHolder = hotTableInstance.current.hotInstance.rootElement.querySelector("div.wtHolder");
        if (wtHolder) {
            wtHolder.style.width = `${finalWidth}px`;
        }

        let ht_clone_top = hotTableInstance.current.hotInstance.rootElement.parentElement.querySelector("div.ht_clone_top.handsontable");
        if (ht_clone_top) {
            ht_clone_top.style.width = `${finalWidth}px`;
            let ht_clone_top_wtHolder = ht_clone_top.querySelector("div.wtHolder");;
            if (ht_clone_top_wtHolder) {
                ht_clone_top_wtHolder.style.width = `${finalWidth}px`;
            }
        }

        /* manually set overflow to visible so tooltips don't get cut off */
        hotTableInstance.current.hotInstance.rootElement.style.overflow = 'visible';

        if (reRender) hotTableInstance.current.hotInstance.render();
    }
}
export function updateColumnWidths(colWidthsOverrides, newSize, column, props) {
    log(`updateColumnWidths`, 1);
    if (colWidthsOverrides[props.tableName] && colWidthsOverrides[props.tableName][column]) {
        colWidthsOverrides[props.tableName][column] = newSize;
    }
    return colWidthsOverrides
}

export function getTableHeaders (displayHelp = true, props) {
    if (props.nestedHeaders) {
        var headers = props.nestedHeaders.map(headerArray => {
            return headerArray.map((header, index) => {
                if (props.helpText && props.helpText[index] !== "" &&

                    !(props.tableName === "Options" &&
                        headerArray[index].label !== undefined)) {

                    if (displayHelp) {
                        const alignmentValue = props.helpTextAlignment?.[index];
                        const alignment = (alignmentValue === 'left' || alignmentValue === 'right') ? ' ' + alignmentValue : '';
                        header = header + " <i class='fas fa-info-circle fa-xs tooltipCustom'><span class='genericTooltip tooltiptext infoBubble" + alignment + "'>" + props.helpText[index] + "</span></i>"
                    }

                }

                if (typeof (header) === 'string') {
                    return injectPlaceholder(header);
                } else {
                    return { ...header, label: injectPlaceholder(header.label) }
                }
            })
        })

        return headers;
    } else {
        return null;
    }
}
export function getAssetTableHeaders(includeHelpText = true, props) {
    log(`getTableHeaders`, 1);
    const headers = props.nestedHeaders.map(headerArray => {
        return headerArray.map((header, index) => {
            if (props.helpText[index] !== "" && includeHelpText || (props.tableName === "options" && index > 10 && props.helpText[index] !== "" && includeHelpText)) {
                const alignmentValue = props.helpTextAlignment?.[index];
                const alignment = (alignmentValue === 'left' || alignmentValue === 'right') ? ' ' + alignmentValue : '';
                header = header + " <i class='fas fa-info-circle fa-xs tooltipCustom'><span class='genericTooltip tooltiptext infoBubble" + alignment + "'>" + props.helpText[index] + "</span></i>"
            }
            if (typeof (header) === 'string') {
                return injectPlaceholder(header);
            } else {
                return { ...header, label: injectPlaceholder(header.label) }
            }
        })
    })

    if (props.tableName === "mandate") {
        if (ibsStore.currentSurvey && !ibsStore.isEnhanced) {
            let hasInternalCosts = getSurveyResponseValue("HasInternalCosts")
            if (hasInternalCosts === false || hasInternalCosts === 0) {
                if (ibsStore.allTableResponses["combinedAssets"]) {
                    let hasInternalStyles = ibsStore.allTableResponses["combinedAssets"]
                        .filter(item => {
                            const styleName = item["StyleName"];
                            return (styleName && typeof styleName == 'string' && styleName.startsWith("Int"));
                        }).length > 0;
                    if (!hasInternalStyles) {
                        //since everything is hard coded...
                        // replace Total Cost with Total Fees
                        headers[0][14] = headers[0][14].replace("Cost", "Fees");
                    }
                }
            }
        }
    }

    return headers;
}

export function getMergedCells (props, listOfHeaderRows) {
    let merged = []

    if (props.tableName === "Benchmark") {
        listOfHeaderRows.forEach(rowIdx => merged.push({ row: rowIdx, col: 0, rowspan: 1, colspan: 2 }))
    }
    return merged;
}


export function isCellNA(row, col, props, referenceToTable, lastEncounteredImplStyle, lastEncounteredAssetCat){
    let assetClassName;
    let colName = props.headers[col]
    let implStyle = lastEncounteredImplStyle; // keep track of styleID instead of styleName to improve the below checks
    let categoryClassName = lastEncounteredAssetCat;

    assetClassName = referenceToTable[row]?.AssetClassNameReal;

    if (props.tableName === "Options" && assetClassName) {
        if (colName === "ReturnPercent" && isAnnualReturnNA(assetClassName)) return true;
        if (colName === "PercentPassive" && isPercentPassiveNA(assetClassName)) return true;
        if (colName === "StyleID" && isMandateStyleNA(assetClassName)) return true;
        if (colName === "MandateStyleName" && isMandateStyleNA(assetClassName)) return true;
    } else if (props.tableName == "mandate") {
        if (colName === "CostManagerBase" && costBaseThousandsNA(implStyle)) return true;
        if (colName === "CostManagerPerf" && performanceFeesNA(categoryClassName, assetClassName, implStyle)) return true;
        if (colName === "UnderlyingFundFees" && underlyingFeesNA(categoryClassName, implStyle)) return true;
        if (colName === "UnderlyingPerfFees" && underlyingFeesNA(categoryClassName, implStyle)) return true;
        if (colName === "HoldingFeeAvg" && isFeeBasisNA(categoryClassName, assetClassName, implStyle)) return true;
        if (colName === "HoldingFeeEnd" && isFeeBasisNA(categoryClassName, assetClassName, implStyle)) return true; //whats going on here
        if (colName === "ReturnTypeIDAssets" && categoryClassName === "Derivatives/Overlays") return true;
        return false;


    }
    return false;
}

export function renderDeleteIconBtn(td, row, props, referenceToTable) {
    let clickDel = document.createElement("i")
    clickDel.innerHTML = " <i class='fa fa-minus-circle del-row-icon' aria-hidden='true' title='Delete Row'></i>"
    clickDel.addEventListener('click', function () {
        deleteRow(row, props, referenceToTable)
    }, false);
    td.replaceChildren(clickDel)
}


export function deleteRow(rowNum, props, referenceToTable) {
    if (rowNum === null || typeof rowNum === 'undefined' || !referenceToTable[rowNum]) {
        return;
    }

    var rowId = "";
    if (props.tableName == "Options") {
        rowId = referenceToTable[rowNum].OptionID;
    } else if (props.tableName == "CustomGroupings") {
        rowId = referenceToTable[rowNum].CustomAssetID;
    } else {
        rowId = referenceToTable[rowNum].RowID; //the rowId 
        if (typeof rowId === "string") {
           rowId = rowId.replace("A", "");
        }
    }
    store.rowToDelete.RowID = rowId;
    store.rowToDelete.TableName = props.tableName;
    if (store.showInternalTeamModal || store.showCustomGroupingModal) {
        let labelText = "row";
        if (store.showInternalTeamModal) labelText = "team"
        let confirmed = window.confirm("Are you sure you want to delete this " + labelText + "?");
        if (confirmed) {
            deleteRowCtrl(store.rowToDelete.RowID, store.rowToDelete.TableName)
        }

    } else {
        store.showDeleteRowModal = true; //would be delete modal instead
    }


}

export function renderOptionIconsBtn(td, row, referenceToTable) {
    let optID = referenceToTable[row].OptionID
    //edit icon for options 
    let clickEdit = document.createElement("i")
    clickEdit.innerHTML = "<i class='fa fa-pen row-icon' aria-hidden='true' title='Edit Row'></i>"
    clickEdit.addEventListener('click', function () {
        editOptionRow(optID)
    }, false);
    td.appendChild(clickEdit)

    //link icon for options
    let optionRow = ibsStore.allTableResponses["Options"].find(row => {
        return row.OptionID == optID
    })

    if (optionRow?.IsExistingOption) {
        let chainLink = document.createElement("i")
        //chainLink.innerHTML = " <i class='fa fa-chain' aria-hidden='true'></i>"
        chainLink.innerHTML = " <i class='fas fa-info-circle fa-xs tooltipCustom'><span class='genericTooltip tooltiptext infoBubble'>" + "This option is linked to its historical data." + "</span></i>"
        td.appendChild(chainLink)
    }
}



export function editOptionRow (rowNum) {
    ibsStore.showOptionRowModal = true;
    ibsStore.tempOptionsRowInfo.OptionID = rowNum
    ibsStore.editOptionModal = true;
    let optionRow = ibsStore.allTableResponses["Options"].find(row => row.OptionID === rowNum);
    ibsStore.tempOptionsRowInfo.ProviderName = optionRow.ProviderName
    ibsStore.tempOptionsRowInfo.OptionName = optionRow.OptionName
    ibsStore.tempOptionsRowInfo.AssetCategoryID = optionRow.AssetClassID
    ibsStore.tempOptionsRowInfo.AssetCategoryName = optionRow.AssetClassName
    ibsStore.tempOptionsRowInfo.MandateStyleName = optionRow.MandateStyleName
    ibsStore.tempOptionsRowInfo.MandateStyleID = optionRow.StyleID
    ibsStore.tempOptionsRowInfo.MorningStarId = optionRow.MorningStarId
    ibsStore.tempOptionsRowInfo.Message = ""
    ibsStore.tempOptionsRowInfo.Ticker = optionRow.Ticker
    ibsStore.tempOptionsRowInfo.ShareClass = optionRow.ShareClass
    ibsStore.tempOptionsRowInfo.UseSecLend = optionRow.UseSecLend
    if (ibsStore.allTableResponses["MappingAM"][ibsStore.tempOptionsRowInfo.AssetCategoryID]) ibsStore.legalStyles = Array.from(ibsStore.allTableResponses["MappingAM"][ibsStore.tempOptionsRowInfo.AssetCategoryID], (obj) => { return obj.StyleName; });

}

export function setPlaceHolderCell(props, td, value, col) {
    if (props?.columns[col].placeholder && value.length == 0) {
        value = props?.columns[col].placeholder
        td.className = td.className + " tablePlaceholder"
    }
    return [td, value]

}

export function loadDefaultTableErrors(listOfErrorWarning){
    if (store.allValidationErrorsList[store.currentLandedPage]) {
        listOfErrorWarning = [];
        store.allValidationErrorsList[store.currentLandedPage].forEach(error => {
            listOfErrorWarning.push({
                "qName": error.QuestionName,
                "rowID": error.RowID,
                "errorTypeID": error.ErrorTypeID,
                "errorMessage": error.ErrorMessage,
                "errorExplanation": error.ErrorExplanation,
                "errorTotalCol": error.totalErrorColumn,
                "errorId": error.ErrorId
            })
        });
    }
    return listOfErrorWarning
}

export function isNotEmptyorNA (value){
    if (value != "" && value != "N/A" && value != null) return true
    return false
}